import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { FirebaseProvider } from './contexts/FirebaseContext';
import { DataProvider } from './contexts/DataContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import NavBar from "./components/NavBar";
import { ProviderProvider } from './contexts/ProviderContext';

import AppRoutes from "./Routes";

const StagingBanner: React.FC = () => (
  <div className="bg-muted-clay  text-white text-sm py-1 text-center">
    Beta Version
  </div>
);

const App: React.FC = () => {
  const isStaging = process.env.REACT_APP_ENVIRONMENT === 'staging';

  return (
    <AuthProvider>
      <FirebaseProvider>
        <ProviderProvider>   
          <DataProvider>
            <div className="bg-muted-lightGrey text-muted-black font-poppins">
              {isStaging && <StagingBanner />}
              <Router>
                <NavBar />
                <AppRoutes />
              </Router>
            </div>
          </DataProvider>
        </ProviderProvider>
      </FirebaseProvider>
    </AuthProvider>
  );
};

export default App;
